import React from "react";
//import styles from "./scss/drafts.module.scss";
import { getTeamMembersnamelist } from "../../../base/utils";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { userStatusColor } from "../../../base/callService/common";
import teamIcn from "../../../styles/images/teamimg.svg";
import converter from 'number-to-words';
// import singleIcon from "../../../styles/images/usersingle.svg";
import singleIcon from "../../../styles/images/Welaunch_Profile_Pic.svg";
import { LoginState, initialStateModel } from "../../../models/model";
import { useSelector } from "react-redux";

type ProfileListProps = {
  contactDetail:any;
  profileSize?:number;
  randomColor?:any;
  plusContent?:any;
}
export default function ProfileAvatarGroup({contactDetail,profileSize,randomColor,plusContent}:ProfileListProps) {
   let userInfo:any = contactDetail;
  let teammembers :any;
  var userSplit:any = "";
  var userTeamSplit:any = "";
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);

  if(contactDetail?.team_id && contactDetail?.team_members){
     teammembers = getTeamMembersnamelist(contactDetail?.team_members);
     if(teammembers?.length > 3){
      userSplit = teammembers?.map((value:any, key:number)=>{
     
        if((teammembers?.length<5 || (teammembers?.length>4 &&  key<3)) && key<teammembers?.length){
          return(<span key={key}>{value?.caller_id?.charAt(0).toUpperCase()}</span>);
        } else if((teammembers?.length>4 &&  key===3)){
          if(plusContent === 1 ){
            return(<span key={key}>{teammembers?.length > 99 ? "9": `${teammembers?.length-4}`}</span>);
          } else {
            return(<span key={key}>{teammembers?.length > 99 ? "+99": `+${teammembers?.length-4}`}</span>);
          }
          
        } else {
          return null;
        }
      });
    }
  }

  if(contactDetail?.team_id && contactDetail?.team_members){
    userTeamSplit = teammembers && teammembers.map((elem: any, index: any) => {
      return (<span key={index}>{elem?.caller_id?.charAt(0).toUpperCase()}</span>
       
      );}
    )
  }

  return (
    <>
    {!userInfo?.team_id && !userInfo?.domain_name &&  userInfo?.is_blocked  === 0&& 
     <URAvatarGroup className={`lefts size${profileSize} colorBG${randomColor} ${(userInfo?.ImageURL !== null && userInfo?.ImageURL !== "")?'avatarWithImg':'' }`}
        profileInfo={
        (userInfo?.ImageURL !== null && userInfo?.ImageURL !== "" && userInfo?.ImageURL !== undefined) ?
        (<>
            <img src={ userInfo?.ImageURL} alt="" />
        <URStatusDot className={ userStatusColor(userInfo?.user_status,'big')} /></>) :
        (<>
           <span>{userInfo?.first_name?.charAt(0).toUpperCase() + userInfo?.last_name?.charAt(0).toUpperCase()} </span>
        <URStatusDot className={ userStatusColor(userInfo?.user_status,'big')} />
        </>)
        
        } />  
        
      }
      {!userInfo?.team_id && userInfo?.domain_name &&  userInfo?.is_blocked  === 0&& 
     <URAvatarGroup className={`lefts size${profileSize}  colorBG${randomColor}`}
        profileInfo={
        ( userInfo?.profile_image_thumbnail !== null &&  userInfo?.profile_image_thumbnail !== "") ?
        (<>
        <img src={ userInfo?.profile_image_thumbnail} alt="" />
        <URStatusDot className={ userStatusColor(userInfo?.user_status,'big')} /></>) :
        (<>
        <img src={userInfo?.profile_image_thumbnail} alt="" />
        <URStatusDot className={ userStatusColor(userInfo?.user_status,'big')} />
        </>)
        
        } />  
        
      }
         {
        userInfo?.is_blocked  === 1&&  
        <URAvatarGroup className= {`lefts size${profileSize}  ${userInfo?.profile_image_url?"avatarWithImg":""}`} profileInfo={
          // ${converter.toWords(teammembers.length)}
          <>
           { userInfo?.profile_image_url?
                     <img src={userInfo?.profile_image_url} alt="" />
                    :
                    //userTeamSplit
                    <span className="singleImgmain"><img src={singleIcon} alt="team icon" /></span>
                 }
          </>}/> 
      }
      {
        userInfo?.team_id &&  (teammembers?.length < 5) &&
        <URAvatarGroup className= {`lefts size${profileSize} colorBG${randomColor} ${userInfo?.profile_image_url?"avatarWithImg":""}`} profileInfo={
          // ${converter.toWords(teammembers.length)}
          <>
           { userInfo?.profile_image_url?
                     <img src={userInfo?.profile_image_url} alt="" />
                    :
                    //userTeamSplit
                    <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>
                 }
          </>}/> 
      }
      {
        userInfo?.sip_login_id === loginDetails?.userdetails?.sip_login_id &&
        <URAvatarGroup className={`lefts size${profileSize}  colorBG${randomColor}  ${userInfo?.ImageURL?"avatarWithImg":""}`}
        profileInfo={
        // ( userInfo?.profile_image_url !== null &&  userInfo?.profile_image_url !== "") ?
        // (<>
        // <img src={ userInfo?.profile_image_url} alt="" />
        // <URStatusDot className={ userStatusColor(userInfo?.user_status,'big')} /></>) :
        (<>
          <span>{userInfo?.caller_id?.charAt(0).toUpperCase()} </span>
        <URStatusDot className={ userStatusColor(userInfo?.user_status,'big')} />
        </>)
        
        } />
      }
      
      {userInfo?.team_id && teammembers?.length !==0 && teammembers?.length > 4 &&
        <URAvatarGroup className={`lefts size${profileSize} colorBG${randomColor} ${userInfo?.profile_image_url?"avatarWithImg":""}`} profileInfo={
          <>
             { userInfo?.profile_image_url?
                     <img src={userInfo?.profile_image_url} alt="" />
                    :
                    <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>
                 }
            
          </>
        }/> 
      }
      {userInfo?.team_id && contactDetail?.team_members=== null &&
        <URAvatarGroup  className={`lefts size${profileSize} colorBG${randomColor} ${userInfo?.profile_image_url?"avatarWithImg":""}`} profileInfo={
        <>
        { userInfo?.profile_image_url?
         <img src={userInfo?.profile_image_url} alt="" />
                    :
                    <span className="teamImg"><img src={teamIcn} alt="team icon" /></span>
                 }
        
        </>
        }/> 
      }
    
     {/* {!userInfo?.team_id && 
     <URAvatarGroup className='lefts size38'
        profileInfo={
        (userInfo?.ImageURL !== null && userInfo?.ImageURL !== "") ?
        (<>
        <img src={userInfo?.ImageURL} alt="" />
        <URStatusDot className={ userStatusColor(userInfo?.user_status,'')} /></>) :
        (<>
        <span>{userInfo?.caller_id?.charAt(0).toUpperCase()} </span>
        <URStatusDot className={ userStatusColor(userInfo?.user_status,'')} />
        </>)
        } />
       }
        {
          userInfo?.team_id &&  (teamMemberNames?.length < 5) &&
          <URAvatarGroup className= {`lefts ${converter.toWords(teamMemberNames.length)}`} profileInfo={
            <>
              {teamMemberNames && teamMemberNames.map((elem: any, index: any) => {
                return (
                  <>
                    <span>{elem?.charAt(0).toUpperCase()}</span>
                  </>
                );}
              )}
            </>}/> 
        }
         {teamMemberNames?.length !== 0 && teamMemberNames?.length > 4 &&
            <URAvatarGroup className='lefts four' profileInfo={
              <>
                {userSplit} 
              </>}/> }*/}
                
    </>
  );
};

